import { flowRight, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import FollowUserButtonMobile from '../../containers/follow-user-button-mobile-secure';
import PublicProfileActions from '../../containers/public-profile-actions';
import MoreButton from '../more-button';
import UserAvatarImage from '../../components/user-avatar-image';
import UserBadge from '../../components/user-badge';
import { getFollowersCount, getPostsCount } from '../../services/counters';
import withAuth from '../../hoc/with-auth';
import withEnvironment from '../../hoc/with-environment';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './member-list-item.scss';

const MoreButtonFix = props => <MoreButton className={styles.moreButton} {...props}/>;

const MemberListItem = ({ contentFontClassName, currentUser, member, navigation: { ProfileLink, FollowersLink }, t }) =>
  <ProfileLink className={classNames(styles.container, contentFontClassName)} user={member}>
    <UserAvatarImage className={styles.avatar} type="member" user={member}/>
    <div className={styles.details}>
      <div className={classNames(styles.name, 'forum-text-color')}>
        {member.name} <UserBadge user={member}/>
      </div>
      <div className={classNames(styles.date, 'forum-text-color')}>
        {t('member-list-item.date', { date: member.createdDate })}
      </div>
      <div className={classNames(styles.stats, 'forum-text-color')}>
        {t('member-list-item.posts-stats', { count: getPostsCount(member) })}
        {' | '}
        <object type="communities/link">
          <FollowersLink className={styles.link} user={member}>
            {t('member-list-item.followers-stats', { count: getFollowersCount(member) })}
          </FollowersLink>
        </object>
      </div>
    </div>
    {get(currentUser, '_id') !== member._id &&
      <div className={styles.actions}>
        <FollowUserButtonMobile user={member}>
          <PublicProfileActions
            triggerButton={MoreButtonFix}
            emptyNode={<div className={styles.spacer}/>}
            user={member}
          />
        </FollowUserButtonMobile>
      </div>}
  </ProfileLink>;

MemberListItem.propTypes = {
  contentFontClassName: PropTypes.string,
  currentUser: PropTypes.object,
  member: PropTypes.object.isRequired,
  navigation: PropTypes.object,
  t: PropTypes.func,
};

export default flowRight(
  withAuth,
  withEnvironment({ navigation: 'navigation' }),
  withFontClassName,
  withTranslate
)(MemberListItem);



// WEBPACK FOOTER //
// ./app/components/member-list-item/member-list-item.js